<orbit-dialog-header
  [title]="'DATE_PICKER.LOCK_TITLE' | translate"
  data-testid="lock-dialog-header" />

<div class="lock-conversation-dialog" data-testid="lock-dialog-content">
  <div class="dialog-content">
    <form [formGroup]="lockForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="lockNote">{{ 'DATE_PICKER.LOCK_NOTE' | translate }}</label>
        <orbit-form-field
          type="text"
          id="lockNote"
          [controller]="lockNote"
          data-testid="lock-note-input" />
      </div>

      <div class="form-group">
        <label for="lockExpiresAt">{{ 'DATE_PICKER.LOCK_EXPIRES_AT' | translate }}</label>
        <orbit-date-picker
          [minDate]="minimumDate()"
          [todayLabel]="todayLabel()"
          [clearLabel]="clearLabel()"
          [monthNames]="monthNames()"
          [weekdayNames]="weekdayNames()"
          formControlName="lockExpiresAt"
          id="lockExpiresAt"
          data-testid="lock-expires-at-picker" />

        @if (lockForm.get('lockExpiresAt')?.invalid && lockForm.get('lockExpiresAt')?.touched) {
          <div class="error-message">
            {{ 'SHARED.LOCK_CONVERSATION.DATE_REQUIRED' | translate }}
          </div>
        }
      </div>
    </form>
  </div>

  <orbit-dialog-footer data-testid="lock-dialog-footer">
    <div class="right-addon" right-addon>
      <orbit-button
        [flat]="true"
        [label]="'SHARED.DIALOGS.CONFIRM_DIALOG.CANCEL_LABEL' | translate"
        (click)="onCancel()"
        data-testid="btn-lock-dialog-cancel" />
      <orbit-button
        [disabled]="lockForm.invalid || isSubmitting()"
        [label]="'SHARED.DIALOGS.CONFIRM_DIALOG.CONFIRM_LABEL' | translate"
        (onClick)="onSubmit()"
        data-testid="btn-lock-dialog-confirm" />
    </div>
  </orbit-dialog-footer>
</div>
